import $ from 'jquery';
import { utils, AlzUtils } from '../common/utils';
import type { IDonation } from '../types';

export class DonationPayment {
    private donation: IDonation;
    private apiurl: string;
    private paymentreferencekey: string;
    private checkout?: Dibs.Checkout;

    constructor(donation: IDonation, apiurl: string, paymentreferencekey: string) {
        this.donation = donation;
        this.apiurl = apiurl;
        this.paymentreferencekey = paymentreferencekey;
    }

    private toggleEditAmount(hide: boolean): void {
        if (hide) {
            this.donation.$DonationElement.find('.donation-editamount').hide();
        } else {
            this.donation.$DonationElement.find('.donation-editamount').show();
        }
    }

    private clearOldContainer(withoutloader: boolean): void {
        const oldcontainer = this.donation.$DonationElement.find('[id^="payment-container-"]');
        if (oldcontainer.length) {
            oldcontainer.html(withoutloader ? ' ' : '');
        }
    }

    private finishCheckOut(response?: unknown): void {
        const redirectUrl = this.donation.$DonationElement.data('alz-thankyou') as string;
        utils.deleteLocalStorage(this.paymentreferencekey);
        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            if (response) {
                const r = response as { checkoutOptions: { containerId: string } };
                $(`#${r.checkoutOptions.containerId}`).html('Betalning lyckades');
            } else {
                this.donation.$DonationElement.find('[id^="payment-container-"]').html('Betalning lyckades');
            }
            this.toggleEditAmount(true);
            utils.checkDataLayerPurchase();
        }
    }

    private initCheckout(response: { checkoutOptions: unknown; pspReferenceId?: string }): void {
        if (this.donation.PaymentMethod === 'card') {
            this.toggleEditAmount(false);
            this.checkout = new Dibs.Checkout(response.checkoutOptions);
            this.checkout.on('payment-completed', () => {
                this.finishCheckOut(response);
            });
        } else {
            this.finishCheckOut(response);
        }
    }

    callbackPayment(): void {
        this.clearOldContainer(false);
        let paymentReference = utils.getFromLocalStorage(this.paymentreferencekey);
        if (paymentReference === 'undefined') paymentReference = null;

        const data = {
            meta: this.donation.$DonationElement.data('alz-meta'),
            amount: this.donation.Amount,
            transactionId: paymentReference,
            paymentmethod: this.donation.PaymentMethod,
            donorInfo: this.donation.DonorInfo,
            honoraryInfo: this.donation.HonoraryInfo,
            deliveryInfo: this.donation.DeliveryInfo
        };

        this.toggleEditAmount(true);

        $.ajax(this.apiurl, {
            method: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8'
        })
            .fail((response) => {
                const json = response.responseJSON as { error?: string };
                const error = json?.error ?? response.statusText as string;
                this.donation.StatusBox.setStatus(error);
                this.clearOldContainer(true);
                this.toggleEditAmount(false);
            })
            .done((response: { error?: string; transactionId?: string; dataLayerPurchase?: unknown; pspReferenceId?: string; checkoutOptions: unknown }) => {
                if (response.error) {
                    this.donation.StatusBox.setStatus(response.error);
                    this.clearOldContainer(true);
                    this.toggleEditAmount(false);
                }
                if (response.transactionId) {
                    if (response.dataLayerPurchase) {
                        utils.setLocalStorage(AlzUtils.DataLayerPurchaseKey, JSON.stringify(response.dataLayerPurchase));
                    }
                    utils.setLocalStorage(this.paymentreferencekey, response.transactionId);
                    if (response.pspReferenceId) {
                        this.initCheckout(response as { checkoutOptions: unknown; pspReferenceId?: string });
                    }
                }
            });
    }
}
